import { EligibleToEditStatuses } from '../../../../../enums/fulfillmentplan-order-grid-status';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../hooks/entities/selectors/fulfillment-plans';

export const useIsFulfillmentPlanEditable = (fulfillmentPlanId) => {
  const orderGridStatus = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'orderGridStatus');
  return EligibleToEditStatuses.includes(orderGridStatus);
};
